import createAxios from "./axiosHttp";

function getTaskById(taskId) {
  const axios = createAxios();
  const urlPath = `ttmm/task/${taskId}`;
  return axios.get(urlPath);
}

function getTasks(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/task/ql";
  return axios.post(urlPath, { pagination, query, sort });
}

function exportar(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/task/ql/export";
  return axios.post(
    urlPath,
    { pagination, query, sort },
    { responseType: "arraybuffer" }
  );
}

function getUnloadCandidates(routeId) {
  const axios = createAxios();
  const urlPath = `ttmm/task/unload-candidates/${routeId}`;
  return axios.get(urlPath);
}

function getLoadCandidates(routeId) {
  const axios = createAxios();
  const urlPath = `ttmm/task/load-candidates/${routeId}`;
  return axios.get(urlPath);
}

function getLocationHistoryQl(query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/task/location-history/ql";
  return axios.post(urlPath, { query, sort });
}

export const taskService = {
  getTaskById,
  getTasks,
  exportar,
  getUnloadCandidates,
  getLoadCandidates,
  getLocationHistoryQl,
};
